/* Infinite scroll — collection page.
 *
 * The collection grid renders `pagination-panda.liquid` (a plain
 * `.pagination-list`) rather than the `.js-pagination` markup that
 * custom-pagination.js observes, so the theme's built-in infinite scroll never
 * engages here. This script replaces it: a sentinel at the end of the results
 * fetches the next page and appends its cards.
 *
 * `facet-filters.js` swaps the whole `#filter-results` container on every
 * filter/sort, which destroys the sentinel and the spinner, so we tear down and
 * re-initialise on `on:facet-filters:updated` — otherwise the shopper would be
 * stranded on page 1 of the filtered results.
 *
 * The pagination links are only hidden once this script is actually running
 * (`c-infinite-scroll-active` on the section): if it never initialises, the
 * shopper keeps working pagination links.
 */
(function () {
  var SECTION_SELECTOR = '.cc-collection-products';
  var RESULTS_SELECTOR = SECTION_SELECTOR + ' .main-products-grid__results';

  var observer = null;
  var sentinel = null;
  var spinner = null;
  var isFetching = false;

  function getResultsContainer() {
    return document.querySelector(RESULTS_SELECTOR);
  }

  function getNextPageUrl() {
    var pagination = document.querySelector(SECTION_SELECTOR + ' .pagination-list');
    if (!pagination) return null;
    var links = pagination.querySelectorAll('a');
    var lastLink = links[links.length - 1];
    if (lastLink && lastLink.textContent.trim() === '>') {
      return lastLink.href;
    }
    return null;
  }

  function createSpinner() {
    var el = document.createElement('div');
    el.className = 'c-pagination-spinner';
    el.innerHTML = '<svg class="c-spinner-svg" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="23" width="2" height="12" rx="1" fill="#C4C4C4"/><rect y="25" width="2" height="12" rx="1" transform="rotate(-90 0 25)" fill="black"/><rect x="12.866" y="45.2842" width="2" height="12" rx="1" transform="rotate(-150 12.866 45.2842)" fill="#2B2B2B"/><rect x="36.866" y="44.2842" width="2" height="12" rx="1" transform="rotate(150 36.866 44.2842)" fill="#575757"/><rect x="45.2847" y="35.1338" width="2" height="12" rx="1" transform="rotate(120 45.2847 35.1338)" fill="#6D6D6D"/><rect x="44.2847" y="11.1338" width="2" height="12" rx="1" transform="rotate(60 44.2847 11.1338)" fill="#989898"/><rect x="25" y="48" width="2" height="12" rx="1" transform="rotate(180 25 48)" fill="#414141"/><rect x="48" y="23" width="2" height="12" rx="1" transform="rotate(90 48 23)" fill="#828282"/><rect x="35.134" y="2.71582" width="2" height="12" rx="1" transform="rotate(30 35.134 2.71582)" fill="#AEAEAE"/><rect x="11.134" y="3.71582" width="2" height="12" rx="1" transform="rotate(-30 11.134 3.71582)" fill="#D9D9D9"/><rect x="2.71533" y="12.8662" width="2" height="12" rx="1" transform="rotate(-60 2.71533 12.8662)" fill="#EFEFEF"/><rect x="3.71533" y="36.8662" width="2" height="12" rx="1" transform="rotate(-120 3.71533 36.8662)" fill="#161616"/></svg>';
    return el;
  }

  function appendProducts(html) {
    var tmpl = document.createElement('template');
    tmpl.innerHTML = html;

    var newItems = tmpl.content.querySelectorAll('.js-pagination-result');
    var grid = document.querySelector(RESULTS_SELECTOR + ' ul[role="list"]');
    if (!grid) return null;

    newItems.forEach(function (item) {
      grid.appendChild(item.cloneNode(true));
    });

    return tmpl.content.querySelector('.pagination-list');
  }

  function updatePaginationState(newPaginationHtml) {
    var existingPagination = document.querySelector(SECTION_SELECTOR + ' .pagination-list');
    if (existingPagination && newPaginationHtml) {
      existingPagination.innerHTML = newPaginationHtml.innerHTML;
    } else if (existingPagination && !newPaginationHtml) {
      existingPagination.remove();
    }
  }

  function fetchNextPage(callback) {
    if (isFetching) return;
    var nextUrl = getNextPageUrl();
    if (!nextUrl) {
      if (callback) callback(false);
      return;
    }

    isFetching = true;

    fetch(nextUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        updatePaginationState(appendProducts(html));

        if (typeof window.initLazyImages === 'function') {
          window.initLazyImages();
        }

        if (callback) callback(!!getNextPageUrl());
      })
      .catch(function (err) {
        console.error('[c-infinite-scroll] fetch error', err);
        if (callback) callback(false);
      })
      .finally(function () {
        isFetching = false;
      });
  }

  function stopObserving() {
    if (observer) observer.disconnect();
    if (sentinel) sentinel.remove();
    if (spinner) spinner.remove();
    observer = null;
    sentinel = null;
    spinner = null;
  }

  /* Full reset, including un-hiding the pagination links. Only used before a
   * re-init: when the last page has simply been reached we stop observing but
   * keep the links hidden, so the shopper isn't shown a pagination list at the
   * bottom of a grid they already scrolled through. */
  function teardown() {
    stopObserving();
    document.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
      section.classList.remove('c-infinite-scroll-active');
    });
  }

  function init() {
    teardown();

    var container = getResultsContainer();
    if (!container || !getNextPageUrl()) return;

    container.closest(SECTION_SELECTOR).classList.add('c-infinite-scroll-active');

    // The theme's own infinite scroll would double up with this one if the
    // collection grid ever switches back to the `.js-pagination` markup.
    // facet-filters.js resets this flag on every filter, hence re-applying it
    // here rather than once on load.
    var customPagination = document.querySelector('custom-pagination');
    if (customPagination) customPagination.dataset.pauseInfiniteScroll = 'true';

    spinner = createSpinner();
    container.appendChild(spinner);

    sentinel = document.createElement('div');
    sentinel.className = 'c-infinite-scroll-sentinel';
    container.appendChild(sentinel);

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || isFetching) return;
          spinner.style.display = 'flex';

          fetchNextPage(function (hasMore) {
            if (spinner) spinner.style.display = 'none';
            if (!hasMore) stopObserving();
          });
        });
      },
      { rootMargin: '600px 0px' }
    );

    observer.observe(sentinel);
  }

  document.addEventListener('on:facet-filters:updated', init);

  init();
})();
